import React from 'react';

const Translated = ({ intl, id, params, className, htmlMode, as }) => {
    const translatingParams = params;

    if (translatingParams) {
        Object.keys(translatingParams).forEach((key) => {
            if (typeof translatingParams[key] === 'string' && translatingParams[key].includes('translatable:')) {
                translatingParams[key] = intl.formatMessage({ id: translatingParams[key].replace('translatable:', '') });
            }
        });
    }

    const translated = intl.formatMessage({ id }, translatingParams);

    if (htmlMode) {
        return <span dangerouslySetInnerHTML={{ __html: translated }} className={className || ''} />;
    }

    if (as || className) {
        const that = { as: as || 'span' };
        return <that.as className={className || ''}>{translated}</that.as>;
    }

    return <React.Fragment>{translated}</React.Fragment>;
};


export default Translated;
